export default {
    WebsiteDeepProfile: {
        Title: "Quét website chuyên sâu - Mục tiêu",
        Name: "Mục tiêu",
        ScanUrl: "Đường dẫn",
        LastScaned: "Lần quét gần nhất",
        NextScaned: "Lần quét tiếp theo",
        Status: "Trạng thái hoạt động",
        Targets: "Website/Đường dẫn",
        Report: "Thống kê an ninh",
        SearchEmptyText: "Tìm theo mục tiêu, địa chỉ mục tiêu",
        TargetsDescription: "google.com,http://dantri.vn\ntuoitre.vn\nkenh14.vn",
        ExcludeDescription: "https://www.google.com/maps/page1\ntuoitre.vn/video.html",
        Exclude: "Bỏ qua các đường dẫn",
        Engine: "Mức độ chuyên sâu",
    },    
    WebsiteWideProfile: {
        Title: "Quét website diện rộng - Mục tiêu",
        Name: "Mục tiêu",
        ScanUrl: "Đường dẫn",
        LastScaned: "Lần quét gần nhất",
        NextScaned: "Lần quét tiếp theo",
        Status: "Trạng thái hoạt động",
        Targets: "Website/Đường dẫn",
        Report: "Thống kê an ninh",
        SearchEmptyText: "Tìm theo tên mục tiêu",
        TargetsDescription: "google.com,http://dantri.vn\ntuoitre.vn\nkenh14.vn",
        ExcludeDescription: "https://www.google.com/maps/page1\ntuoitre.vn/video.html",
        Exclude: "Bỏ qua các đường dẫn",
        Engine: "Mức độ chuyên sâu",
        ScanPortCount: "Số cổng tìm thấy",
    },
    Website: {
        Title: 'Danh sách website',
        SearchEmptyText: "Tìm theo đường dẫn tìm kiếm",
        ScanUrl: "Đường dẫn",
    },
    ScanEngine: {
        Title: "Danh sách Engine",
        SearchEmptyText: "Tìm theo tên Engine",
        Name: "Tên",
        Code: "Mã",
        DeployInfo: "Thông tin máy chủ",
        ScanConfig: "Cấu hình",
        Inactive: "Ngưng hoạt động"
    },
    WebsitesIssues: {
        Title: "Quét website chuyên sâu - Danh sách nguy cơ"
    }
};  
